<div class="contact-wrapper">
  <div class="container">
<!--    <div class="main-page-title inverted">KAPCSOLAT-->
<!--      <div class="three-dot">-->
<!--        <div class="dot first"></div>-->
<!--        <div class="dot second"></div>-->
<!--      </div>-->
<!--    </div>-->


    <app-section-heading [light]="true" [label]="'Kapcsolat'"></app-section-heading>

    <div class="row">
      <div class="col-12 col-sm-6 text-row">
        <div class="info-line overflow-ellipsis">
          <i class="marker icon"></i>9141 Ikrény, Ipar u. 1.
        </div>

        <div class="info-line overflow-ellipsis">
          <i class="mail icon"></i>kulcsrakesz@schatzhaz.hu
        </div>

        <div class="info-line overflow-ellipsis">
          <i class="phone icon"></i> +36 20 465 62 10
        </div>

      </div>
      <div class="col-12 col-sm-6 map-row">

        <div class="contact-map-wrapper solid-shadow">

          <agm-map
            [latitude]="47.676412"
            [longitude]="17.540130"
            [zoom]="12"
            [styles]="customGoogleMapStyle"
            [scrollwheel]="true"
            [disableDefaultUI]="true"
            [zoomControl]="true"
            (mapReady)="onMapReady($event)">

            <agm-marker
              [latitude]="47.676412"
              [iconUrl]="'./assets/images/place-marker.png'"
              [longitude]="17.540130">
            </agm-marker>

          </agm-map>

        </div>

      </div>
    </div>


  </div>
</div>
